import React from 'react';
import 'tailwindcss/tailwind.css';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

// Import images
import Image1 from '../../../../Data/img/mehendi/arabicnew.jpg';
import Image2 from '../../../../Data/img/mehendi/arabicnew1.jpg';
import Image3 from '../../../../Data/img/mehendi/bridal1.jpg';
import Image4 from '../../../../Data/img/mehendi/bridal3.jpg';
import Image5 from '../../../../Data/img/mehendi/carwa1.png';
import Image6 from '../../../../Data/img/mehendi/arabicnew.jpg';
import Image7 from '../../../../Data/img/mehendi/arabicnew1.jpg';
import Image8 from '../../../../Data/img/mehendi/bridal1.jpg';

// Sample images and categories
const images = [
  { src: Image1, category: 'Long Mehendi Design' },
  { src: Image2, category: 'Pooja Mehendi Design' },
  { src: Image3, category: 'Karwa Chauth Design' },
  { src: Image4, category: 'wedding Mehendi Design' },
  { src: Image5, category: 'Karwa Portrait Design' },
  { src: Image6, category: 'Flower Mehendi Design' },
  { src: Image7, category: 'Heavy Mehendi Design' },
  { src: Image8, category: 'Husband & Wife Mehendi' },
];

const GalleryPhoto = () => {
  return (
    <div className="py-10 px-4 bg-gray-100">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {images.map((item, index) => (
          <div key={index} className="relative group cursor-pointer">
            <Zoom>
              <img
                src={item.src}
                alt={`Gallery image ${index + 1}`}
                className="w-full h-[20rem] object-cover rounded-lg shadow-lg transition-transform duration-300 transform group-hover:scale-105"
              />
            </Zoom>
            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-center py-2 rounded-b-lg">
              {item.category}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GalleryPhoto;
